import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createTypeManager, editTypeManager, 
getActiveTypeManager, getInactiveTypeManager,
getActivePermissions, deleteTypeManager } from '../../actions/permissionsAction'
import { Translate } from '../../../language';
import { UseComponentVisible2 } from '../../../containers/UseComponentVisible2'
import { ReactComponent as CloseIcon } from '../../../img/ic_cerrar.svg';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const TypeManagerAdmin = ({ history, createTypeManager, editTypeManager, isLoadinglistInactiveTypeManager, listInactiveTypeManager, listActivePermission, getActivePermissions, listActiveTypeManager, isLoadinglistActivePermission, getActiveTypeManager, getInactiveTypeManager, deleteTypeManager, isLoadinglistActiveTypeManager }) => {

    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getActiveTypeManager()
            getInactiveTypeManager()
        })
        
    },[])

    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [nameTypeManager, setNameTypeManager] = useState('')
    const [description, setDescription] = useState('')
    const [permissions, setPermissions] = useState('')
    const [code, setCode] = useState('')
    const [permissionsID, setPermissionsID] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})
    const [isEnable, setEnable] = useState(false)


    console.log()
    useEffect(() => {
        if (nameTypeManager === '' || description === '' || permissions === '' || code === '') {
            setValidate(false)
        }

        if (nameTypeManager !== '' && description !== '' && permissions !== '' && code !== '') {
            setValidate(true)
        }
    }, [permissions])

    const deletePermissionTag = (id) => {

        setPermissions(prevState => {
            var prevStateDelete = prevState
            delete prevStateDelete[id]
            return ({ ...prevStateDelete })
        })
    }

    useEffect(() => {
        getActivePermissions()
    }, [])
    const {
        ref2,
        isComponentVisible2,
        setIsComponentVisible2
    } = UseComponentVisible2(false);

    const isEmpty = (e) => {
        console.log()
        if (nameTypeManager === '' || description === '' || permissions === '' || code === '') {
            setValidate(false)
        }

        if (nameTypeManager !== '' && description !== '' && permissions !== '' && code !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        console.log()
        if (value.length === 0) {

            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));




        }

    }




    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }




    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nuevo'} rol de comunidades`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Nombre de rol:'}
                    </div>
                    <input
                        className='inputs-admin'
                        name="nameTypeManager"
                        value={nameTypeManager}
                        type="text"
                        onChange={e => setNameTypeManager(e.target.value.trimStart())}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                        onMouseOut={e => setNameTypeManager(e.target.value.trim())}
                    />
                    <div className="text-error text-error-admin">{error.nameTypeManager}</div>
                    <div className="text-input-admin">
                        {'Descripción:'}
                    </div>
                    <input
                        className='inputs-admin'
                        name="description"
                        value={description}
                        type="text"
                        autoComplete='off'
                        onChange={e => setDescription(e.target.value.trimStart())}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                        onMouseOut={e => setDescription(e.target.value.trim())}
                    />
                    <div className="text-error text-error-admin">{error.description}</div>
                    <div className="text-input-admin">
                        {'Código:'}
                    </div>
                    <input
                        className='inputs-admin'
                        name="code"
                        value={code}
                        type="number"
                        autoComplete='off'
                        onChange={e => setCode(e.target.value.trimStart())}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                        onMouseOut={e => setCode(e.target.value.trim())}
                    />
                    <div className="text-error text-error-admin">{error.code}</div>

                    <div className="text-input-admin">
                        {'Permisos:'}
                    </div>
                    <div className="search-invite-room">
                        <div ref2={ref2}>
                            <div
                                className="modal-content-button-search-bar"
                                onClick={() =>
                                    setIsComponentVisible2(true)
                                }
                            >
                                <div>
                                    <input className='inputs-admin' onChange={(e) => {
                                        console.log()
                                    }} type="text" />
                                </div>
                            </div>
                            {isComponentVisible2 &&
                                <div className='scroll-menu modal-search-bar'>
                                    <div className="modal-results-search-bar">
                                        <div>
                                            {isLoadinglistActivePermission ? <div></div> :
                                                listActivePermission.map((permission) => (
                                                    !permissions[permission._id] &&
                                                    <div
                                                        className="column centerItems"
                                                        key={permission._id}
                                                        onClick={() => {
                                                            setIsComponentVisible2(false)
                                                            setPermissions(prevState => { return { ...prevState, [permission._id]: permission } })
                                                            setPermissionsID(prevState => { return { ...prevState, [permission._id]: permission._id } })
                                                        }} >
                                                        {permission.name}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div>
                            {Object.values(permissions).length > 0 ?
                                Object.values(permissions).map(permission =>
                                    <div className="relative">
                                        <div style={{ width: '80%' }}>
                                            <div className="textBlack" name={permission.name} />{permission.name} </div>
                                        <div onClick={() =>
                                            deletePermissionTag(permission._id)
                                        } className="delete-invite-permissions-icon ml-2">
                                            <CloseIcon className="cls-1" height="18" width="18" />
                                        </div>
                                    </div>
                                )
                                :
                                <div>

                                </div>}
                        </div>
                    </div>

                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setNameTypeManager('')
                                setPermissionsID({})
                                setPermissions({})
                                setDescription('')
                                setCode('')
                                setEnable(false)
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editTypeManager({ name: nameTypeManager, description: description,code:code, permissions: Object.keys(permissions), id: idEdit }, history, undefined, indexEdit)
                                    setNameTypeManager('')
                                    setPermissionsID({})
                                    setPermissions({})
                                    setCode('')
                                    setDescription('')
                                    setEnable(false)
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { createTypeManager({ name: nameTypeManager, description: description,code:code, permissions: Object.keys(permissions) }, history) }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>
                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Tipos de roles habilitados para comunidades</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadinglistActiveTypeManager ? <div>Cargando...</div> :
                        listActiveTypeManager.map((typeManager, index) => (
                            <div key={typeManager._id} className="card-admin">
                                <div className="tittle-card-admin">{typeManager.name}</div>
                                <div className="text-content-card ">{typeManager.description}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setNameTypeManager(typeManager.name)
                                        setDescription(typeManager.description)
                                        setCode(typeManager.code)
                                        setPermissions({})
                                        typeManager.permissions.map((permission, index) => (setPermissions(prevState => { return { ...prevState, [permission._id]: permission } })))
                                        setIdEdit(typeManager._id)
                                        setEnable(typeManager.isEnable)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deleteTypeManager(typeManager._id, index, 'activeTypeManager') }}>Eliminar</div>
                                    <div className="btns-admin ml-1 btns-admin-inactive" onClick={() => { editTypeManager({ id: typeManager._id, isEnabled: false }, history, 'deactivate', index) }}>Desactivar</div>

                                </div>
                            </div>
                        ))
                    }
                </div>

                <div className='title-admin-list mt-4'>Tipos de roles inhabilitados para comunidades</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadinglistInactiveTypeManager ? <div>Cargando...</div> :
                        listInactiveTypeManager.map((typeManager, index) => (
                            <div key={typeManager._id} className="card-admin">
                                <div className="tittle-card-admin">{typeManager.name}</div>
                                <div className="text-content-card ">{typeManager.description}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin mr-1 " onClick={() => { editTypeManager({ id: typeManager._id, isEnabled: true }, history, 'activate', index) }}>Activar</div>
                                    <div className="btns-admin btns-admin-inactive" onClick={() => { deleteTypeManager(typeManager._id, index, 'inactiveTypeManager') }}>Eliminar</div>


                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>



        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadinglistActivePermission: state.permissionsAdmin.isLoadinglistActivePermission,
        listActivePermission: state.permissionsAdmin.listActivePermission,
        isLoadinglistActiveTypeManager: state.permissionsAdmin.isLoadinglistActiveTypeManager,
        listActiveTypeManager: state.permissionsAdmin.listActiveTypeManager,
        isLoadinglistInactiveTypeManager: state.permissionsAdmin.isLoadinglistInactiveTypeManager,
        listInactiveTypeManager: state.permissionsAdmin.listInactiveTypeManager
    }
}


export default connect(mapStateToProps, { createTypeManager, editTypeManager, getActiveTypeManager, getInactiveTypeManager, getActivePermissions, deleteTypeManager })(TypeManagerAdmin)